/* unplugin-vue-components disabled */import script from "./AttractInvestProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AttractInvestProduct.vue?vue&type=script&setup=true&lang=js"

import "./AttractInvestProduct.vue?vue&type=style&index=0&id=625d613a&lang=scss"

const __exports__ = script;

export default __exports__